import { createSvgIcon } from '@mui/material';

const DownloadSKU = createSvgIcon(
  <svg
    width="21.855"
    height="18.559999"
    viewBox="0 0 21.855 18.56"
    version="1.1"
    id="svg1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g
      id="Group_4146"
      data-name="Group 4146"
      transform="matrix(0.83843053,0,0,0.83843053,-1.1582377,-3.5164137)"
    >
      <path
        id="Path_2562"
        data-name="Path 2562"
        d="m 19,18 a 3.5,3.5 0 1 0 0,-7 H 18 A 5.093,5.093 0 0 0 13.611,5.05 5.621,5.621 0 0 0 7,9 4.574,4.574 0 0 0 2.334,12.373 4.349,4.349 0 0 0 4.9,17.4"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.3"
      />
      <line
        id="Line_617"
        data-name="Line 617"
        y2="9"
        transform="translate(12,13)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        x1="0"
        y1="0"
        x2="0"
      />
      <path
        id="Path_2563"
        data-name="Path 2563"
        d="m 9,19 3,3 3,-3"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
    <g transform="translate(0.1, 1.7)">
      <path
        style={{
          fontWeight: 'bold',
          fontSize: '6.28711px',
          fontFamily: 'Barlow',
          fill: '#12344A',
          strokeWidth: '0.758281',
        }}
        d="m 8.2605349,18.56 q -0.727951,0 -1.2739147,-0.227484 Q 6.440658,18.095932 6.1403778,17.668261 5.8491983,17.231489 5.8491983,16.65823 v -0.200188 q 0,-0.04551 0.027296,-0.0728 0.0364,-0.0364 0.081889,-0.0364 H 6.995714 q 0.045503,0 0.0728,0.0364 0.0364,0.0273 0.0364,0.0728 v 0.136496 q 0,0.363975 0.3366772,0.618757 0.3366772,0.245684 0.9099384,0.245684 0.4822676,0 0.7188519,-0.200186 0.2365827,-0.209286 0.2365827,-0.509565 0,-0.218386 -0.145589,-0.363977 Q 9.0157837,16.230561 8.761001,16.121369 8.5153176,16.003081 7.9693539,15.802891 7.3596957,15.593606 6.9320249,15.37522 6.5134533,15.156834 6.2222723,14.78376 5.9401921,14.401585 5.9401921,13.846525 q 0,-0.545964 0.2820802,-0.955437 0.2820818,-0.409472 0.7825478,-0.627857 0.5004661,-0.218385 1.1556219,-0.218385 0.6915527,0 1.2284156,0.245683 0.5459637,0.245684 0.8462444,0.691553 0.309377,0.43677 0.309377,1.019131 v 0.136495 q 0,0.04551 -0.0364,0.08189 -0.0273,0.0273 -0.0728,0.0273 H 9.3888576 q -0.045489,0 -0.081889,-0.0273 -0.027296,-0.0364 -0.027296,-0.08189 v -0.0728 q 0,-0.382173 -0.3184787,-0.646056 -0.309378,-0.272981 -0.8553416,-0.272981 -0.4276709,0 -0.6733543,0.181987 -0.2365841,0.18199 -0.2365841,0.500467 0,0.227485 0.1364955,0.382174 0.1455891,0.15469 0.4185716,0.282081 0.2820804,0.118288 0.8644409,0.327577 0.6460566,0.236585 1.0100313,0.418572 0.3730756,0.181988 0.6642558,0.545964 0.30028,0.354875 0.30028,0.928137 0,0.855342 -0.6278586,1.355809 Q 9.3342735,18.56 8.2605461,18.56 Z m 3.3394671,-0.0728 q -0.04551,0 -0.08189,-0.0273 -0.0273,-0.0364 -0.0273,-0.08189 v -6.151184 q 0,-0.04551 0.0273,-0.07281 0.0364,-0.0364 0.08189,-0.0364 h 1.064629 q 0.04549,0 0.0728,0.0364 0.0364,0.0273 0.0364,0.07281 v 2.547828 q 0,0.0273 0.01819,0.0364 0.01821,0 0.0364,-0.01819 l 2.101958,-2.611524 q 0.05459,-0.0637 0.136496,-0.0637 h 1.201117 q 0.0728,0 0.09099,0.04551 0.01821,0.0364 -0.01819,0.09099 l -2.029162,2.593325 q -0.0273,0.0364 -0.0091,0.0637 l 2.147454,3.448667 q 0.01819,0.05459 0.01819,0.0637 0,0.0637 -0.091,0.0637 h -1.201119 q -0.091,0 -0.127391,-0.07279 l -1.619677,-2.620637 q -0.0091,-0.01819 -0.0273,-0.01819 -0.01821,0 -0.0364,0.01819 l -0.573262,0.718852 q -0.01819,0.0364 -0.01819,0.05459 v 1.810779 q 0,0.04551 -0.0364,0.08189 -0.0273,0.0273 -0.0728,0.0273 z m 7.898261,0.0728 q -0.700652,0 -1.237516,-0.272982 -0.527763,-0.27298 -0.828044,-0.764347 -0.291179,-0.500467 -0.291179,-1.146523 v -4.149319 q 0,-0.0455 0.0273,-0.0728 0.0364,-0.0364 0.08189,-0.0364 h 1.064629 q 0.04551,0 0.0728,0.0364 0.0364,0.0273 0.0364,0.0728 v 4.158418 q 0,0.482268 0.29118,0.782548 0.300279,0.291179 0.782547,0.291179 0.482267,0 0.773447,-0.291179 Q 20.572,16.867515 20.572,16.385247 v -4.158418 q 0,-0.0455 0.0273,-0.0728 0.0364,-0.0364 0.08189,-0.0364 h 1.064629 q 0.04551,0 0.0728,0.0364 0.0364,0.0273 0.0364,0.0728 v 4.149319 q 0,0.646056 -0.30028,1.146523 -0.291182,0.491367 -0.828044,0.764347 Q 20.198915,18.56 19.498262,18.56 Z"
        id="text1"
        aria-label="SKU"
      />
    </g>
  </svg>,
  'DownloadSKU',
);

export default DownloadSKU;
